module.exports = __webpack_public_path__ + "static/media/b7-北大街.b4f99634.png";